module.exports = __webpack_public_path__ + "assets/gr.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/modern/gr.png
// module id = 431
// module chunks = 0